import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useSearchParams = () => {
  const location = useLocation();
  return useMemo(() => new URLSearchParams(location.search), [location]);
};

export default useSearchParams;
